import { Component } from '@angular/core';

@Component({
  selector: 'app-user-table-top-container',
  template: `
    <ng-content></ng-content>
  `,
  styleUrls: ['./user-table-top-container.component.scss'],
  standalone: false,
})
export class UserTableTopContainerComponent {}
